import { ComponentType, FC } from 'react'
import { twMerge } from 'tailwind-merge'

type IconSize = 'small' | 'medium' | 'large' | 'extraLarge'

export interface IconProps {
  size?: IconSize
  height?: number
  width?: number
  fill?: string
  className?: string
}

const sizeClasses: Record<IconSize, string> = {
  small: '!w-4 !h-4',
  medium: '!w-6 !h-6',
  large: '!w-8 !h-8',
  extraLarge: '!w-12 !h-12',
}

const Icon = (IconComponent: ComponentType<any>) => {
  const WrappedIcon: FC<IconProps & Record<string, any>> = ({
    size = 'medium',
    height,
    width,
    fill = 'currentColor',
    className,
    ...props
  }) => {
    const sizeClass = sizeClasses[size]
    const customSize = height && width ? { height, width } : {}

    return (
      <IconComponent
        fill={fill}
        className={twMerge(sizeClass, className)}
        {...customSize}
        {...props}
      />
    )
  }

  return WrappedIcon
}

export default Icon
